"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = require("./js/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WrappedIcon = function WrappedIcon(props) {
  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      "svg",
      { viewBox: "0 0 1152 1152" },
      _react2.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", fill: "#FF1828", d: "M0 576c0 318.1 257.9 576 576 576s576-257.9 576-576S894.1 0 576 0 0 257.9 0 576zm59.4 0C59.4 290.3 290.7 58.8 576 58.8s516.6 231.6 516.6 517.2-231.3 517.2-516.6 517.2S59.4 861.7 59.4 576z" }),
      _react2.default.createElement("path", { fill: "#290608", d: "M883.5 353.4L615.8 209.6c-11.7-6.3-26.2-5.9-37.6.8-11.4 6.8-19 18.9-19 32.3v26.2L485 228.4c-5.8-3.2-11.5-4.1-18-4.7-2.4-.1-7.5-.1-8.5 0-24 2.3-44.3 22-44.3 46.5V506c0 26.3 22.6 47.7 48.8 47.7 9.5 0 16.9-3 22.3-6l217.3-119.4c15.2-8.4 24.8-24.5 24.7-42-.1-17.4-11-33.4-26.4-41.6L576 278.4v-35.7c0-7 5-13.4 10.9-16.9 5.9-3.5 13.7-3.7 19.8-.4l268 143.8c6.5 3.5 10.5 10 10.5 17.3 0 7.3-3.7 13.8-10.1 17.3L565.6 574.1 256.3 739.5c-12.3 6.6-19.7 19-19.7 33s7.2 26.3 19.4 33l267.6 147.3c5.7 3.1 11.8 4.7 18 4.7 6.5 0 11.6-1.7 17.5-5.2 11.5-6.8 16.9-18.9 16.9-32.3v-28.5l68.4 36.8c4.3 2.4 10 5.1 18.2 5.1 22.5 0 41.7-18.4 41.7-41.1V656.4c0-20.5-15.1-37.8-34.8-40.8-1.3-.3-2.8-.6-4.2-.6h-2.1c-1.5 0-3 .3-4.4.7-4.3.7-8.6 2.2-12.9 4.5L429.1 736.8c-13.2 7.1-21.5 20.9-21.6 36-.1 15 7.2 28.8 20.4 36.1l131.4 72.8V920c0 7.1-2.7 13.4-8.7 17-5.9 3.5-12.7 3.6-18.7.3L264.4 789.9c-6.4-3.5-10.1-10-10.1-17.3 0-7.4 4-13.8 10.4-17.3l309.5-165.4 309.6-170.4c12.2-6.7 19.5-19.1 19.4-33 0-14.1-7.4-26.4-19.7-33.1zM443.2 772.9c0-1.2.4-3.4 2.8-4.7l211.6-113.7c.6-.3 2.5-1.5 3.1-1.6 3.3-1.6 4.6.5 4.6 3.6v235.8c0 3.1-1.4 5.4-3.9 4.1-.3-.2-1.6-.7-2.1-1L445.5 777.5c-2.2-1.2-2.3-3.1-2.3-4.6z" })
    )
  );
};

WrappedIcon.displayName = 'AdobePrimetimeColorLight';
exports.default = WrappedIcon;

